import styled from '@emotion/styled';
import { Colors } from '../../../../../colors';
import { Box, Grid, List, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { mediaQueryMobileLimit } from '../../../../../utils/constants';


export const HeaderStyled = {
  Container: styled(Grid) <any>`
    width: 100%;
    height: 85px;
    display: flex;
    align-items: center;
    justify-content: space-around;
    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.16);
    position: fixed;
    z-index: 10;
    background: ${Colors.White};
    
  `,

  LogoContainer: styled(Grid) <any>`
    padding-left: 30px;
    display: flex;
    color: #3579ba;
    @media (max-width: ${mediaQueryMobileLimit}px) {
      max-width: 200px;
      padding-left: 0px;
      
    }
  `,

  LogoText: styled.h1<any>`
    font-size: 27px;
    font-weight: bold;
    color: #3579ba;
    font-family: EncodeSans-Medium;
  `,

  MobileMenuButton: styled(Box) <any>`
    display: none;
    @media (max-width: ${mediaQueryMobileLimit}px) {
      display: block;
    }
  `,

  ListContainer: styled(List) <any>`
    width: 200px;
    padding: 30px;
  `,

  CentralContainer: styled(Grid) <any>`
    display: flex;
    justify-content: center;
    gap: 40px;
    @media (max-width: ${mediaQueryMobileLimit}px) {
      display: none;
    }
  `,

  OptionsLabels: styled.div<any>`
    font-family: EncodeSans-Medium;
    text-decoration: none;
    color: #000;
    cursor: pointer;
  `,

  LoginContainer: styled(Grid) <any>`
    display: flex;
    justify-content: end;
    align-items: center;
    gap: 20px;
    padding-right: 50px;
    @media (max-width: ${mediaQueryMobileLimit}px) {
      padding-right: 0px;
    }
  `,

  ButtonBox: styled(Box) <any>`
    width: 151px;
    @media (max-width: ${mediaQueryMobileLimit}px) {
      display: none;
    }
  `,

  Link: styled(Link) <any>`
    width: 151px;
    text-decoration: none;
  `,

  UserBox: styled(Link) <any>`
    display: flex;
    text-decoration: none;
    color: #000;
    height: 22px;
  `,

  Login: styled(Typography) <any>`
    @media (max-width: ${mediaQueryMobileLimit}px) {
      display: none;
    }
    font-family: EncodeSans-Medium;
  `,
};
